package com.bikompanion.data

val isDebugBuild: Boolean
    get() = BuildKonfig.IS_DEBUG

val appVersionName: String
    get() = BuildKonfig.VERSION_NAME
